import { createHttpClient } from './createHttpClient';

// In prod mode we send requests directlyc

const apiHttpClient = createHttpClient();

export { apiHttpClient };
